import { createStore, applyMiddleware, compose } from 'redux'
import { createBrowserHistory, createMemoryHistory } from 'history'
import { createReducer } from './reducers'

export const history =
  typeof document !== 'undefined'
    ? createBrowserHistory()
    : createMemoryHistory()

export const configureStore = (initialState = {}, middlewares = []) => {
  const enhancers = [applyMiddleware(...middlewares)]

  /* eslint-disable no-underscore-dangle */
  const composeEnhancers =
    ((typeof window !== 'undefined' &&
      window.location.search.includes('godmode=true')) ||
      (process.env.NODE_ENV !== 'production' &&
        typeof window !== 'undefined')) &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
      ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({})
      : compose
  /* eslint-enable */

  const store = createStore(
    createReducer(history),
    initialState,
    composeEnhancers(...enhancers),
  )
  return store
}
